import { useRoutes } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Login from "../pages/login";
import Dashboard from "../pages/dashboard";
import Protected from "../utils/protected";
import DetailTransaction from "../pages/detailTransaction";
import { loggedIn, notOps } from "../store/gloabalState";
import RedirectAuth from "../utils/redirect";
import Home from "../pages/home";
import AllTransaction from "../pages/allTransactions";
import OrganisationView from "../pages/organisation";
import CreateUser from "../pages/createUser";
import CreateVendor from "../pages/createVendor";
import CreateOrg from "../pages/createOrg";
import OnboardOrg from '../pages/onboard-org';
import UpdateTransaction from "../pages/updateTransaction";
import ViewVendor from "../pages/viewVendors";
import CreateTransaction from "../pages/createTransaction";
import CreateCaFirm from "../pages/createCaFirm";
import AddCA from "../pages/addCa";
import AddBank from "../pages/addBank";
import AddBankUser from "../pages/addBankUser";
import ViewBank from "../pages/viewBank";
import DocumentsSignup from "../components/Document_signup/DocumentsSignup";
import OrganizationNewView from "../pages/OrganizationNewView";
import Leads from "../pages/Leads";
import { useEffect, useState } from "react";
import CaBillings from "../pages/caBillings";
import Cookies from "js-cookie";
import NotFoundPage from "../pages/notFoundPage";
import InwardTransactions from "../pages/inward-transactions";
import InwardTransactionDetail from "../pages/inward-transaction-detail";
import UpdateInwardTransaction from "../pages/udpate-inward-transaction";

export default function Routes() {
  const isLoggedIn = useRecoilValue(loggedIn);
  const notOps_ = useRecoilValue(notOps)

  useEffect(() => {
    let userInfo = Cookies.get("userInfo");
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
    }
    let url_ = window.location.pathname
    if (url_) {
      url_ = url_?.split('/')
      if (url_[1] !== "onboardorg" && url_[1] !== "orgedit" && url_[1] !== "orgdetails") {
        localStorage.removeItem("orgId")
      }
    }
  }, [notOps_])

  return useRoutes([
    {
      path: "/login",
      element: <Login />,
      exact: true,
    },
    {
      path: "/",
      exact: true,
      element: (
        <Protected isLoggedIn={isLoggedIn}>
          <Dashboard />
        </Protected>
      ),
      children: [
        { path: "/", exact: true, element: notOps_ ? <Leads /> : <Home /> },
        { path: "/alltransactions", exactp: true, element: <AllTransaction /> },
        { path: "/inwardtransactions", exact: true, element: <InwardTransactions/> },
        {
          path: "/transactiondetail/:id",
          exact: true,
          element: notOps_ ? <NotFoundPage /> : <DetailTransaction />,
        },
        {
          path: "/transactiondetail/inward/:id",
          exact: true,
          element: notOps_ ? <NotFoundPage/> : <InwardTransactionDetail/>
        },
        { path: "/vieworg", exact: true, element: notOps_ ? <NotFoundPage /> : <OrganisationView /> },
        { path: "/orgs", exact: true, element: <OrganizationNewView /> },
        { path: "/adduser", exact: true, element: notOps_ ? <NotFoundPage /> : <CreateUser /> },
        { path: "/addvendor", exact: true, element: notOps_ ? <NotFoundPage /> : <CreateVendor /> },
        { path: "/onboardorg", exact: true, element: <OnboardOrg /> },
        { path: "/orgdetails/:id", exact: true, element: <OnboardOrg /> },
        { path: "/orgedit/:id", exact: true, element: <OnboardOrg /> },
        {
          path: "/signdocs",
          exact: true,
          element: notOps_ ? <NotFoundPage /> : <DocumentsSignup />,
        },
        {
          path: "/leads",
          exact: true,
          element: <Leads />
        },
        { path: "/addorg", exact: true, element: notOps_ ? <NotFoundPage /> : <CreateOrg /> },
        { path: "/update/:id", exact: true, element: notOps_ ? <NotFoundPage /> : <UpdateTransaction /> },
        { path: "/updateinward/:id", exact: true, element: notOps_ ? <NotFoundPage/> : <UpdateInwardTransaction/> },
        { path: "/viewvendor", exact: true, element: notOps_ ? <NotFoundPage /> : <ViewVendor /> },
        { path: "/editvendor/:id", exact: true, element: notOps_ ? <NotFoundPage /> : <CreateVendor /> },
        {
          path: "/createtransaction",
          exact: true,
          element: notOps_ ? <NotFoundPage /> : <CreateTransaction />,
        },
        { path: "/editorg/:id", exact: true, element: notOps_ ? <NotFoundPage /> : <CreateOrg /> },
        { path: "/editBank/:id/:index", exact: true, element: notOps_ ? <NotFoundPage /> : <CreateOrg /> },
        { path: "/editAdBank/:id/:index", exact: true, element: notOps_ ? <NotFoundPage /> : <CreateOrg /> },
        { path: "/addcafirm", exact: true, element: notOps_ ? <NotFoundPage /> : <CreateCaFirm /> },
        { path: "/addca", exact: true, element: notOps_ ? <NotFoundPage /> : <AddCA /> },
        { path: "/addbank", exact: true, element: notOps_ ? <NotFoundPage /> : <AddBank /> },
        { path: "/addbankuser", exact: true, element: notOps_ ? <NotFoundPage /> : <AddBankUser /> },
        { path: "/viewBank", exact: true, element: notOps_ ? <NotFoundPage /> : <ViewBank /> },
        { path: "/editbank/:id", exact: true, element: notOps_ ? <NotFoundPage /> : <AddBank /> },
        {
          path: "/editbankuser/:id/:id",
          exact: true,
          element: notOps_ ? <NotFoundPage /> : <AddBankUser />,
        },
        { path: "/cabillings", exact: true, element: notOps_ ? <NotFoundPage /> : <CaBillings /> },
        // { path: "/traxbillings", exact: true, element: <OrganizationNewView /> },
      ],
    },
    {
      path: "/login",
      element: (
        <RedirectAuth>
          <Login />
        </RedirectAuth>
      ),
    },
  ]);
}
